import { invitationLabelDescriptions, TInvitationLabel } from '@/utils/invitationDisplay';
import { CheckIcon, RepeatIcon, TimeIcon, WarningIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { Badge, ComponentWithAs, HStack, IconProps, Text, Tooltip, VStack } from '@chakra-ui/react';

// The icon carries the status without relying on colour alone (colour blindness).
const labelIcons: Record<TInvitationLabel, ComponentWithAs<'svg', IconProps>> = {
  Accepted: CheckIcon,
  Pending: TimeIcon,
  Expired: WarningTwoIcon,
  'Unfinished revoke': WarningTwoIcon,
  'Needs support': WarningIcon,
  Sanitizing: RepeatIcon,
  Reissuing: RepeatIcon,
  Removing: RepeatIcon,
};

// Grouped by what the admin should do: green done, blue waiting on the user,
// orange needs a follow-up, red needs support, purple a process is running.
const labelColorSchemes: Record<TInvitationLabel, string> = {
  Accepted: 'green',
  Pending: 'blue',
  Expired: 'orange',
  'Unfinished revoke': 'orange',
  'Needs support': 'red',
  Sanitizing: 'purple',
  Reissuing: 'purple',
  Removing: 'purple',
};

type Props = {
  label: TInvitationLabel;
  // Row-specific context (e.g. why support is needed), shown under the description.
  detail?: string;
};

const InvitationStatusBadge = ({ label, detail }: Props) => {
  const Icon = labelIcons[label];

  return (
    <Tooltip
      hasArrow
      placement={'top'}
      maxWidth={'280px'}
      label={
        <VStack alignItems={'flex-start'} spacing={'4px'}>
          <Text>{invitationLabelDescriptions[label]}</Text>
          {detail && <Text fontWeight={600}>{detail}</Text>}
        </VStack>
      }
    >
      <Badge
        colorScheme={labelColorSchemes[label]}
        borderRadius={'full'}
        paddingX={'10px'}
        paddingY={'2px'}
        textTransform={'none'}
        fontSize={'12px'}
        fontWeight={600}
        cursor={'help'}
      >
        <HStack spacing={'5px'}>
          <Icon boxSize={'10px'} aria-hidden />
          <Text as="span">{label}</Text>
        </HStack>
      </Badge>
    </Tooltip>
  );
};

export default InvitationStatusBadge;
